import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '../../../components/common/Button';
import { HOME } from '../../../routes/paths';
import FormMessage from '../../FormMessage';
import Translation from '../../i18n/Translation';
import { isNewAccount } from '../selectors';

export const LinkSuccess = ({ history, newAccount }) => (
  <div className="link-success container--fixed">
    <FormMessage className="link-success__message" slotId="default" />
    <div className="link-success__box">
      <h2 className="link-success__heading">
        <Translation section="linkingAccounts" label="successHeader" />
      </h2>
      <p className="link-success__paragraph">
        <Translation section="linkingAccounts" label="successInfo" />
      </p>
      <Button
        className="link-success__button"
        onClick={() => window.open('http://williamhill.com', '_blank')}
      >
        <Translation section="linkingAccounts" label="goToOnline" />
      </Button>
      <Button
        className="button--secondary link-success__button"
        onClick={() => history.push(HOME)}
      >
        <Translation section="linkingAccounts" label="goToHome" />
      </Button>
    </div>
    <a
      className="link-success__terms"
      href={newAccount ? api_config.online_promo_new_account : api_config.online_promo_old_account}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Translation
        section="linkingAccounts"
        label={newAccount ? 'termsForNewAccount' : 'termsForOldAccount'}
      />
    </a>
  </div>
);

LinkSuccess.propTypes = {
  history: PropTypes.object.isRequired,
  newAccount: PropTypes.bool
};

const mapStateToProps = state => ({
  newAccount: isNewAccount(state)
});

export default withRouter(connect(mapStateToProps)(LinkSuccess));
